import React from "react";
import styled from "styled-components";

const CardWrap = ({children, className}) => {
    return <StyledCardWrap className={className}>{children}</StyledCardWrap>;
};

const StyledCardWrap = styled.div`
    width: 100%;
    border-radius: 12px;
    background: #fff;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.05);
    padding: 32px;
`;


export default CardWrap;
